module.exports = __webpack_public_path__ + "static/img/main3_2.407130cd.png";